import React, { useMemo } from 'react';

const TestimonialCardSimple = ({ testimonial, className }) => {

    // format the name from name and organization
    const name = useMemo(() => {
        // if it's just the name, return it
        if (testimonial?.name && !testimonial?.organization) {
            return testimonial.name;
        }

        // if it's just an organization, return it
        if (testimonial?.organization && !testimonial?.name) {
            return testimonial.organization;
        }

        // if its both, return both
        if (testimonial?.name && testimonial?.organization) {
            return `${testimonial.name} (${testimonial.organization})`;
        }
    }, [testimonial]);

    return (
        <div className={'flex flex-row' + className}>
            <div className='flex flex-row items-center gap-2 md:gap-5 lg:gap-10 mx-auto w-full'>
                <img
                    src='/assets/muzology-heart.png'
                    alt='Muzology Heart Logo'
                    className='hidden sm:block flex-shrink-0 w-20 h-20 lg:w-32 lg:h-32'
                />
                <div className='flex flex-col justify-stretch items-center gap-2 w-full max-w-[900px]'>
                    {testimonial?.quote && (<div className='text-left font-Inter text-base md:text-xl font-medium leading-normal lg:leading-8 [color:#505050]'>
                        &ldquo;{testimonial.quote}&rdquo;
                    </div>)}
                    {name && (<div className='font-Inter w-full text-left text-base sm:text-lg md:text-xl font-bold [color:#505050] mt-1'>
                        &mdash; {name}
                    </div>)}
                </div>
            </div>
        </div>
    );
};

const TestimonialListSimple = ({ testimonials, sliceNumber }) => {
    const sliced = testimonials?.slice(0, sliceNumber) ?? [];

    return (
        <div className='default-px mt-0 lg:mt-0 w-full'>
            <div className='mx-auto default-max-w '>
                <div className='flex flex-col gap-6 justify-items-center justify-center'>
                    {sliced.map((testimonials, index) => {
                        return (
                            <TestimonialCardSimple
                                key={index}
                                testimonial={testimonials}
                                className='min-h-[80px] lg:min-h-[106px]'
                            />
                        );
                    })}
                </div>
            </div>
        </div>
    );
};


export default TestimonialListSimple;
